import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'numberWithCommas',
    standalone: false
})
export class NumberWithCommasPipe implements PipeTransform {
  transform(input: any): string {
    if (input != null && input != undefined && input != '') {
      let num = input.toString();
      
      if (Math.abs(parseFloat(input)) >= 1) {
        num = num.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      }
      
      // Convert negative numbers to parentheses format (like AngularJS)
      if (num.indexOf("-") >= 0) {
        num = "(" + num.replace("-", "") + ")";
      }
      
      return num;
    }
    
    return input;
  }
}
